import {
  TableTruncate as SharedTableTruncate,
  TableTruncateProps as SharedTableTruncateProps,
} from "@flaminem/ui-components";
import { FC } from "react";

export type TableTruncateProps = SharedTableTruncateProps;

export const TableTruncate: FC<TableTruncateProps> = ({ ...props }) => {
  return <SharedTableTruncate {...props} />;
};
